<template>
    <div class="row justify-content-center">
        <div class="col action-wrap">
            <button class="button button--solid" @click="submitForm">Submit</button>
        </div>
    </div>
</template>

<script>
    import {DISPLAY_RESULT, ERROR, REMOVE_ERROR} from "../store/mutation-types";
    import VueScrollTo from 'vue-scrollto'
    export default {
        name: "Action",
        methods: {
            submitForm: function() {
                this.$store.commit(DISPLAY_RESULT, false);
                this.validate();
                if (this.isValid) {
                    this.$gtag.logStep('Calculation', 'EV Cost Savings widget');
                    this.$store.commit(DISPLAY_RESULT, true);
                    VueScrollTo.scrollTo('.action-wrap', 500);
                } else {
                    VueScrollTo.scrollTo('#app', 500);
                }
            },
            validate() {
                this.$store.commit(REMOVE_ERROR, 'vehicleSelect');
                if (this.$store.state.SELECTED_VEHICLE.id === 0) {
                    this.$store.commit(ERROR, {name: 'vehicleSelect', message: "Please select a vehicle"})
                }
            }
        },
        computed: {
            isValid: function() {
                if (Object.entries(this.$store.state.ERRORS).length !== 0 && this.$store.state.ERRORS.constructor === Object) {
                    if (Object.entries(this.$store.state.ERRORS).length === 1 && this.$store.state.ERRORS.petrol && this.$store.state.FUEL_TYPE === "diesel") {
                        return true;
                    } else if (Object.entries(this.$store.state.ERRORS).length === 1 && this.$store.state.ERRORS.diesel && this.$store.state.FUEL_TYPE === "petrol") {
                        return true;
                    } else {
                        return false;
                    }
                }
                return true;
            }
        }
    }
</script>

<style scoped lang="stylus">
    .action-wrap
        margin-top 2rem
        margin-bottom 4rem
        text-align center
</style>